import apiService from './apiServices';
import { useMutation } from '@tanstack/react-query';
import { apiServiceRTQ } from './apiShow';
import { showToast } from '@/utils/toastMessage/ToastMessage';

/**
 * @namespace CreateAllData
 * @description A collection of functions to handle various data creation and update operations.
 */
export const CreateAllData = {
  /**
   * Creates a new item by sending a POST request to the specified URL with the provided values.
   *
   * @async
   * @function createItem
   * @memberof CreateAllData
   * @param {string} url - The URL to which the POST request will be sent.
   * @param {Object} values - The values to be sent in the POST request body.
   * @returns {Promise<Object>} The response from the API.
   */
  createItem: async (url, values) => {
    return await apiServiceRTQ.post(url, values);
  },

  /**
   * Changes the password by sending a PATCH request to the specified URL with the provided values.
   *
   * @async
   * @function ChangePassword
   * @memberof CreateAllData
   * @param {string} url - The URL to which the PATCH request will be sent.
   * @param {Object} values - The values to be sent in the PATCH request body.
   * @returns {Promise<Object>} The response from the API.
   */
  ChangePassword: async (url, values) => {
    return await apiServiceRTQ.patch(url, values);
  },
};

export const usePostApi = ({ url, onSuccess }) => {
  return useMutation({
    mutationFn: (values, options) => apiServiceRTQ.post(url, values, options),
    onSuccess: (data) => {
      showToast(data?.response, 'success');
    },
    onError: (error) => {},
  });
};
